import {FC} from 'react';
import {Helper} from '@tickchak/react-share/app';
import Input from '../../../../../../component/input/Input';
import TextEditorFormik from '../../../../../../component/textEditor/TextEditorFormik';
import Pencil from '../../../../../../assets/icons/Pencil';
import LinkIcon from '../../../../../../assets/icons/LinkIcon';
import SectionBox from '../../SectionBox/SectionBox';
import {inputDefaults} from './types';
import {SUMMARY_MAX} from '../../constants';
import * as css from '../AddLecturerPopup.css';

const AboutTab: FC<{t: (k: string) => string}> = ({t}) => (
    <css.aboutWrap>
        <SectionBox title={t('lecturerAboutTitle')} subtitle={t('lecturerAboutSubtitle')}>
            <css.summaryField>
                <css.summaryHeader>
                    <css.summaryIcon><Pencil /></css.summaryIcon>
                    <css.summaryLabel>{t('summaryPlaceholder')}</css.summaryLabel>
                </css.summaryHeader>
                <css.editorWrap>
                    <TextEditorFormik
                        name="about"
                        showToolbar
                        limit={{maxChar: SUMMARY_MAX, showCharCounter: true, softLimit: true}}
                        minHeight="180px"
                        placeholder={t('summaryPlaceholder')}
                    />
                </css.editorWrap>
            </css.summaryField>
        </SectionBox>
        <SectionBox title={t('lecturerLinks')} titleIcon={<Helper size='small' />}>
            <Input {...inputDefaults} name="link" text={t('lecturerLink')} icon={<LinkIcon />} />
            <Input {...inputDefaults} name="liveLink" text={t('lecturerLiveLink')} description={t('lecturerLiveLinkDescription')} icon={<LinkIcon />} />
        </SectionBox>
    </css.aboutWrap>
);

export default AboutTab;
